<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروها">
      <div class="search-area">
        <div class="search-input-area">
          <div class="fancy-title-wrapper search-input-area" style="padding-bottom: 10px;">
            <div class="fancy-title light">
              <h3 class="center text-white">جستجو سریع خودرو</h3>
            </div>
          </div>
          <input type="text" v-model="searchInput" class="form-control"
                 placeholder="نام برند، مدل یا بخشی از نام خودرو را بنویسید">
        </div>
        <div class="result-area ion-padding">
          <div class="table-responsive" v-if="searchResults && searchResults.length">
            <table class="table table-sm">
              <thead>
              <tr>
                <th style="width: 80px;">تصویر</th>
                <th>عنوان</th>
                <th>برند</th>
                <th>مدل</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in searchResults" :key="item._id" @click="goToSinglePage(item._id)">
                <td style="width: 80px;">
                  <img class="thumbnail" :src="item.pic_url"/>
                </td>
                <td style="min-width: 150px;">{{ item.title }}</td>
                <td>{{ item.car_brand.title }}</td>
                <td>{{ item.car_model.title }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br/>
      <ion-grid>
        <ion-row>
          <ion-col size="6" v-for="item in brands" :key="item._id">
            <router-link :to="'/cars/brand/'+item._id">
              <div class="brand-model-item">
                <div class="thumbnail">
                  <img :src="item.pic_url"/>
                </div>
                <div class="title">
                  <h4>{{ item.title }}</h4>
                </div>
              </div>
            </router-link>
          </ion-col>
        </ion-row>
      </ion-grid>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonGrid, IonRow, IonCol, IonPage} from '@ionic/vue'
import {mapActions} from "vuex";

export default {
  name: "brands",
  data: function ()
  {
    return {
      searchInput: '',
      searchResults: [],
      brands: []
    }
  },
  mounted()
  {
    this.searchBrands().then((result) =>
    {
      if (result && result.carBrands)
        this.brands = result.carBrands
    })
  },
  methods: {
    ...mapActions("car", {
      searchCars: 'searchCarType',
      searchBrands: 'searchCarBrand',
    }),
    goToSinglePage(id)
    {
      this.$router.push({path: '/cars/type/' + id})
    }
  },
  watch: {
    searchInput: async function ()
    {
      const result = await this.searchCars({query: this.searchInput});
      if (result && result.carTypes)
      {
        this.searchResults = result.carTypes.slice(0, 8);
      }
    }
  },
  components: {
    IonGrid, IonRow, IonCol, IonPage
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}
.thumbnail{
  text-align: center;
}
.thumbnail img{
  width: 125px;
  height: 125px;
  border-radius: 5px;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}
</style>